// extracted by mini-css-extract-plugin
export default {"container":"NewWishlist_container__MO0cP"};